import type { CardHooks } from "./registry";

/**
 * Hardened Steel — engine: the data-driven mechanics array on the card
 * already handles "+1 stamina on attack-deals-damage" via condition:
 * attack-deals-damage. No hook needed; left as a no-op so the registry
 * lookup for the canonical name still resolves.
 */
export const hardenedSteel: CardHooks = {};
